import JobImg1 from "../../images/tesla.png"


class JobsAPI {
  static jobs = [{
    image: JobImg1,
    company: 'Tesla Private Limited',
    location: 'Bangalore',
    role: 'UI/UX Designer',
    desc: 'As a business owner or manager, what would it look like to have what would it look like to...',
    postedOn: '01 June 2022',
    salary: {
        amount: '₹5 - ₹7 Lacs',
        cycle: 'Annum'
    }
  },
  {
    image: JobImg1,
    company: 'Tesla Private Limited',
    location: 'Bangalore',
    role: 'UI/UX Designer',
    desc: 'As a business owner or manager, what would it look like to have what would it look like to...',
    postedOn: '01 June 2022',
    salary: {
        amount: '₹5 - ₹7 Lacs',
        cycle: 'Annum'
    }
  },
  {
    image: JobImg1,
    company: 'Tesla Private Limited',
    location: 'Bangalore',
    role: 'UI/UX Designer',
    desc: 'As a business owner or manager, what would it look like to have what would it look like to...',
    postedOn: '01 June 2022',
    salary: {
        amount: '₹5 - ₹7 Lacs',
        cycle: 'Annum'
    }
  },
  {
    image: JobImg1,
    company: 'Tesla Private Limited',
    location: 'Bangalore',
    role: 'UI/UX Designer',
    desc: 'As a business owner or manager, what would it look like to have what would it look like to...',
    postedOn: '01 June 2022',
    salary: {
        amount: '₹5 - ₹7 Lacs',
        cycle: 'Annum'
    }
  }
  ];


  static getJobs = () => {
    //change this api calling logic with actual API
    return this.jobs;
  }

//   static getTalentDetails = (id) => {
//     return {
//       talentDetails: this.talentDesc,
//       similarTalents: this.getTalents()
//     }

//   }


}
export default JobsAPI;